export default __webpack_public_path__ + "static/media/deployed-code-account-white.ba88f676.svg";